<template>
    <modal-component @close="close">
        <template v-slot:header>
            <h1>Subscription Required</h1>
        </template>
        
        <p>It appears you don't have an active subscription yet. This action requires you to have an active subscription.</p>

        <template v-slot:footer>
            <button class="py-2 px-4 rounded-md bg-primary text-white font-bold" @click.prevent="goToBilling">Manage subscription</button>
            <button class="ml-2 py-2 px-4 rounded-md bg-primary-lightest" @click="close">Cancel</button>
        </template>
    </modal-component>
</template>

<script>
export default {
    data() {
        return {
            loading: false,
        }
    },
    methods: {
        goToBilling() {
            window.location = '/billing';
        },
        close() {
            this.$emit('close');
        }
    }
}
</script>